import { ActionsObject, makeAction, makeReducer } from '@finn-no/redux-actions';

import { Hotel } from '../interfaces';
import defaultState from './defaultState';

export const actions: ActionsObject<Hotel> = {};

actions.setHotel = makeAction('HOTEL', (_, action) => ({ ...defaultState.hotel, ...action.payload }));

export const hotelReducer = makeReducer<Hotel>(actions);
